<!--
 * @Author: your name
 * @Date: 2020-07-29 14:01:57
 * @LastEditTime: 2021-03-16 14:21:28
 * @LastEditors: lizhihang
 * @Description: In User Settings Edit
 * @FilePath: \xdap-h5\src\pages\blank\public-form\public-business-form\public-business-form.vue
-->
<template>
  <div ref="appEngineFormDom" class="app-engine-form public-business-form">
    <form-build-render
      ref="formRender"
      :renderSence="renderSence"
      :formItemList="formItemList"
      :formData.sync="formData"
      :globalData="globalData"
      :formRuleConfig="formRuleConfig"
      @formEventEmit="formEventEmit"
    ></form-build-render>
  </div>
</template>

<script>
import apis from '@/api'
import FormBuildEngine from '@/lib/ui/components/form/form-build-engine'
import { SET_COMP_PAYLOAD, CLEAR_COMPROUTER_STORE } from '@/store/comp-router.store.js'
import { SET_FORM_CONFIG_BY_FORM_ID, REMOVE_FORM_CONFIG_BY_FORM_ID } from '@/store/form.store.js'
import { mapMutations, mapState } from 'vuex'
import FormRuleExecutorMixin from '@/mixin/form-rule-executor.mixin'

export default {
  name: 'PublicBusinessForm',
  mixins: [FormRuleExecutorMixin],
  props: {
    formType: {
      type: String,
      default: 'EDIT_FORM'
    },
    renderSence: {
      type: String,
      default: 'edit'
    },
    globalData: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  inject: ['addKeepAlive', 'removeKeepAlive', '$blank'],
  provide() {
    return {
      $compRouter: {
        push: this.compRouterPush
      }
    }
  },
  data() {
    return {
      optionButtons: [],
      formData: {},
      editConfig: {
        xdapFormConfig: {},
        componentStatusList: []
      },
      formItemValidateInfoList: [],
      rowId: null,
      haveProcess: false,
      processStatus: '',
      dataStatisticsList: []
    }
  },
  computed: {
    ...mapState({
      compPayload: (state) => state.compRouterModule.compPayload
    }),

    formItemList() {
      if (
        this.editConfig.xdapFormConfig &&
        this.editConfig.xdapFormConfig.detailPage &&
        this.editConfig.xdapFormConfig.detailPage.formComponents
      ) {
        const formItemList = this.editConfig.xdapFormConfig.detailPage.formComponents
          .map((itemConfig) => {
            const formItemConfig = FormBuildEngine.getInstance().getComponentConfigWithType(
              itemConfig.componentType
            )

            // 配置数据
            const componentStatus = this.editConfig.componentStatusList.find((status) => {
              return status.uuid === itemConfig.uuid
            })

            // 处理表格只读数据
            if (formItemConfig.componentType === 'FORM_WIDGET_TABLE') {
              const tableColumnStatus = componentStatus.tableColumnStatus

              const tableColumn = itemConfig.tableColumn

              tableColumn.map((column) => {
                const columnStatus = tableColumnStatus.find((status) => {
                  return status.uuid === column.uuid
                })

                column.originReadOnly = column.readOnly
                column.enableReadOnlyRule = column.readOnly
                column.enableHiddenRule = column.hidden
                column.enableRequiredRule = column.required

                if (!columnStatus) {
                } else if (columnStatus.status === 'READONLY') {
                  column.readOnly = true
                } else if (columnStatus.status === 'HIDDEN') {
                  column.hidden = true
                } else if (columnStatus.status === 'EDITABLE') {
                  column.readOnly = false
                  column.hidden = false
                }
              })
            }

            const statusConfig = {}
            itemConfig.enableReadOnlyRule = itemConfig.readOnly
            itemConfig.enableHiddenRule = itemConfig.hidden
            itemConfig.enableRequiredRule = itemConfig.required
            if (!componentStatus) {
            } else if (componentStatus.status === 'READONLY') {
              statusConfig.readOnly = true
            } else if (componentStatus.status === 'HIDDEN') {
              statusConfig.hidden = true
            } else if (componentStatus.status === 'EDITABLE') {
              statusConfig.readOnly = false
              statusConfig.hidden = false
            }

            // if (statusConfig.hidden) {
            //   return undefined
            // }

            const itemClass =
              this.selectedComponentConfig && this.selectedComponentConfig.uuid === itemConfig.uuid
                ? 'is-selected'
                : ''
            return {
              ...formItemConfig,
              componentConfig: {
                ...formItemConfig.componentConfig,
                ...itemConfig,
                ...statusConfig
              },
              itemClass: itemClass,
              // 组件校验状态，默认校验通过
              validateInfo: this.formItemValidateInfoList.filter(
                (item) => item.uuid === itemConfig.uuid
              )[0] || {
                uuid: itemConfig.uuid,
                validate: 'validate'
              }
            }
          })
          .filter((item) => !!item)
        return formItemList
      } else {
        return []
      }
    },

    computFormFields() {
      const formFields = []
      this.formItemList.forEach((item) => {
        if (item.componentConfig.componentType === 'FORM_WIDGET_TABLE') {
          formFields.push(item.componentConfig)
          item.componentConfig.tableColumn.forEach((column) => {
            formFields.push({
              tableUuid: item.componentConfig.uuid,
              ...column
            })
          })
        } else {
          formFields.push(item.componentConfig)
        }
      })
      return formFields
    }
  },
  activated() {
    this.registerFormContextMethod()
    if (this.compPayload) {
      this.removeKeepAlive(this.$blank.$options.name)
      let compPayload = this.compPayload[this.compPayload.activeKey]
      if (compPayload.callback instanceof Function && compPayload.dirty) {
        // 兼容非表单的情况，后续可以考虑均采用这种方式
        compPayload.callback(compPayload.value)
        return
      }
      if (
        !this.compPayload[this.compPayload.activeKey] ||
        !this.compPayload[this.compPayload.activeKey].value
      ) {
        return
      }
      const keys = this.compPayload.activeKey.split('.')
      if (keys.length > 1) {
        // 表格
        if (keys[1] === 'add') {
          if (this.compPayload[this.compPayload.activeKey].value.$deleted) {
            return
          }
          let tableData = this.formData[keys[0]]
          if (!tableData) {
            tableData = []
          }
          tableData.unshift(this.compPayload[this.compPayload.activeKey].value)
          this.$set(this.formData, keys[0], tableData)
          this.formData = { ...this.formData }
          this.clearCompRoterStore(this.compPayload.activeKey)
        } else {
          const index = Number(keys[1])
          const compPayloadValue = this.compPayload[this.compPayload.activeKey].value
          if (compPayloadValue.$deleted) {
            let tableData = this.formData[keys[0]]
            if (tableData) {
              tableData.splice(index, 1)
              this.$set(this.formData, keys[0], tableData)
            }
          } else {
            this.$set(this.formData[keys[0]], index, compPayloadValue)
          }
          this.$set(this.formData, keys[0], this.formData[keys[0]])
          this.formData = { ...this.formData }
          this.clearCompRoterStore(this.compPayload.activeKey)
        }
      } else {
        this.$set(
          this.formData,
          this.compPayload.activeKey,
          this.compPayload[this.compPayload.activeKey].value
        )
        this.formData = { ...this.formData }
        this.clearCompRoterStore(this.compPayload.activeKey)
      }
    }
  },
  beforeDestroy() {
    this.removeFormConfigByFormId(this.formId)
  },
  methods: {
    ...mapMutations('compRouterModule', {
      setCompPayload: SET_COMP_PAYLOAD,
      clearCompRoterStore: CLEAR_COMPROUTER_STORE
    }),
    ...mapMutations('formModule', {
      setFormConfigByFormId: SET_FORM_CONFIG_BY_FORM_ID,
      removeFormConfigByFormId: REMOVE_FORM_CONFIG_BY_FORM_ID
    }),
    init() {
      this.initFormConfigAndData()
    },
    compRouterPush(compName, compPayload) {
      compPayload && this.setCompPayload(compPayload) // key widgetConfig value
      this.addKeepAlive(this.$blank.$options.name)
      this.$nextTick(() => {
        if (typeof compName === 'object') {
          // 兼容关联表单
          this.$router.push(compName)
        } else {
          this.$router.push({
            name: compName,
            params: {
              id: 'all',
              orgId: this.$route.query.tenantId
            },
            query: {
              appId: this.$route.query.appId,
              key: compPayload.key,
              formId: this.$route.query.formId,
              documentId: this.$route.query.documentId,
              menuId: this.$route.query.menuId,
              inTable: compPayload.inTable,
              tableUUID: compPayload.tableUUID
            }
          })
        }
      })
    },
    initFormConfigAndData() {
      // 此处可以使用并列请求，后续改进，request-plugin支持串行和并行请求
      const request = { ...apis.APP_PAGE.DETAIL_PAGE_CONFIG_BY_ID }
      request.params = {
        formId: this.globalData.formId,
        documentId: this.globalData.documentId,
        type: this.formType
      }
      // this.pushFormLoadingStack('formConfig')
      this.$request(request)
        .asyncThen(
          (res) => {
            if (typeof this.globalData.displayAll === 'boolean' && !this.globalData.displayAll) {
              res.data.xdapFormConfig.detailPage.formComponents = res.data.xdapFormConfig.detailPage.formComponents.filter(
                (comp) => {
                  return (
                    this.globalData.displayComponents.findIndex((uuid) => uuid === comp.uuid) !== -1
                  )
                }
              )
            }
            this.editConfig = {
              ...this.editConfig,
              xdapFormConfig: res.data.xdapFormConfig,
              componentStatusList: res.data.componentStatusList
            }
            this.setFormConfigByFormId({
              formId: this.globalData.formId,
              formConfig: this.editConfig
            })
            // this.popFormLoadingStack('formConfig')
            this.initRuleTriggerDeps()
            if (this.globalData.documentId) {
              this.initData()
            } else {
              // 如果是新增, 设置默认值
              this.initDefaultData()
            }
            this.storageDataStatisticsComponent(res.data)
          },
          (err) => {
            console.error(err)
            // this.popFormLoadingStack('formConfig')
          }
        )
        .asyncErrorCatch((err) => {
          console.error(err)
          // this.popFormLoadingStack('formConfig')
        })
    },
    initData() {
      this.formData = {}
      const detailRequest = { ...apis.APP_PAGE.DETAIL_PAGE_GET_BUSINESS_DATA }
      detailRequest.params = {
        formId: this.globalData.formId,
        documentId: this.globalData.documentId
      }
      // this.pushFormLoadingStack('formData')
      this.$request(detailRequest)
        .asyncThen(
          (detailRes) => {
            const formData = detailRes.data.data
            this.haveProcess = detailRes.data.haveProcess
            this.processStatus = detailRes.data.status
            this.formData = {
              ...this.formData,
              ...formData
            }
            this.initDataStatistics()
            this.rowId = detailRes.data.rowId
            this.globalData.formData = this.formData
            this.triggerRule()
            // this.popFormLoadingStack('formData')
          },
          () => {
            // this.popFormLoadingStack('formData')
          }
        )
        .asyncErrorCatch(() => {
          // this.popFormLoadingStack('formData')
        })

      // 初始化表单数据
      setTimeout(() => {
        const tableUuids = this.formItemList
          .map((formItem) => {
            if (formItem.componentType === 'FORM_WIDGET_TABLE') {
              return formItem.componentConfig.uuid
            } else {
              return undefined
            }
          })
          .filter((uuid) => uuid)

        tableUuids.forEach((uuid) => {
          const detailTableRequest = { ...apis.APP_PAGE.DETAIL_PAGE_GET_TABLE_BUSINESS_DATA }
          detailTableRequest.params = {
            formId: this.globalData.formId,
            documentId: this.globalData.documentId,
            tableUuid: uuid
          }
          // this.pushFormLoadingStack('tableData' + uuid)
          this.$request(detailTableRequest)
            .asyncThen(
              (detailRes) => {
                const tableData = detailRes.data.tableData
                this.formData = {
                  ...this.formData,
                  ...tableData
                }
                this.globalData.formData = this.formData
                // this.popFormLoadingStack('tableData' + uuid)
              },
              () => {
                // this.popFormLoadingStack('tableData' + uuid)
              }
            )
            .asyncErrorCatch(() => {
              // this.popFormLoadingStack('tableData' + uuid)
            })
        })
      })
    },
    initDefaultData() {
      if (Array.isArray(this.formItemList)) {
        this.formItemList.forEach((formItem) => {
          if (
            formItem.componentConfig.defaultValue ||
            formItem.componentConfig[formItem.componentConfig.customDefaultKey]
          ) {
            if (
              formItem.componentConfig.methods &&
              formItem.componentConfig.methods.lcConvertDefaultValue
            ) {
              this.formData[
                formItem.componentConfig.uuid
              ] = formItem.componentConfig.methods.lcConvertDefaultValue(formItem.componentConfig)
            } else {
              this.formData[formItem.componentConfig.uuid] = formItem.componentConfig.defaultValue
            }
          }
        })
      }
      this.initDataStatistics()
      this.triggerRule()
    },
    initDataStatistics() {
      this.$emit('changeGlobalData', false)
      setTimeout(() => {
        this.$emit('changeGlobalData', true)
      }, 600)
    },
    filterDataStatistics(formData) {
      // 过滤data中的数据统计组件
      if (this.dataStatisticsList && this.dataStatisticsList.length > 0) {
        this.dataStatisticsList.forEach((item) => {
          if (formData.hasOwnProperty(item)) {
            delete formData[item]
          }
        })
      }
    },
    storageDataStatisticsComponent(data) {
      // 记录表单内的数据统计组件
      this.dataStatisticsList = []
      setTimeout(() => {
        if (data.componentStatusList) {
          this.dataStatisticsList = data.componentStatusList
            .filter((com) => com.componentType === 'FORM_DATA_STATISTICS')
            .map((item) => item.uuid)
        }
      })
    },
    validate(callback) {
      this.$refs.formRender.validate((validate, error) => {
        if (validate) {
          const tableUuids = this.formItemList
            .map((formItem) => {
              if (formItem.componentType === 'FORM_WIDGET_TABLE') {
                return formItem.componentConfig.uuid
              } else {
                return undefined
              }
            })
            .filter((uuid) => uuid)

          const tableData = {}
          const formData = JSON.parse(JSON.stringify(this.formData))

          tableUuids.forEach((uuid) => {
            tableData[uuid] = formData[uuid]
            delete formData[uuid]
          })
          this.filterDataStatistics(formData)
          callback(formData, this.rowId, tableData)
        } else {
          this.scrollToError()
        }
      })
    },
    scrollToError() {
      setTimeout(() => {
        const isError = this.$refs.appEngineFormDom.getElementsByClassName('is-error')
        const dom = isError[0].parentElement
        dom.scrollIntoView({
          // 滚动到指定节点
          block: 'start', // 值有start,center,end，nearest，当前显示在视图区域开始
          behavior: 'smooth' // 值有auto、instant,smooth，缓动动画（当前是慢速的）
        })
      }, 100)
    }
  }
}
</script>

<style lang="scss">
.public-business-form {
  position: relative;
  height: 100%;
  .form-build-render {
    height: calc(100% - 3.428rem);
    overflow-y: hidden;
    background-color: $--app-body-bgColor !important;
    .x-proxy-form-item.disabled,
    .x-proxy-form-item.disabled .cube-input,
    .x-proxy-form-item.readonly-background,
    .x-proxy-form-item.readonly-background .cube-input {
      background-color: $--app-box-bgColor !important;
    }
  }
}
</style>
